import { render } from "./WhatsNewDialog.vue?vue&type=template&id=2e8933b2&scoped=true&ts=true"
import script from "./WhatsNewDialog.vue?vue&type=script&lang=ts"
export * from "./WhatsNewDialog.vue?vue&type=script&lang=ts"

import "./WhatsNewDialog.vue?vue&type=style&index=0&id=2e8933b2&scoped=true&lang=css"
import "./WhatsNewDialog.vue?vue&type=style&index=1&id=2e8933b2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8933b2"]])

export default __exports__